<template>
  <div class="topmain">
    <van-nav-bar title="MCDEX时讯"  left-text="返回" left-arrow @click-left="onClickLeft"></van-nav-bar>  
    <div class="titlesubbig bottonline deptclass">
      <span>{{Mc_issue}}</span>
      <span class="all" @click="showPicker = true">全部</span>
    </div>
    <div class="deptclass" style="font-size:0.12rem;color:#B9B1B1;">检索到<span style="color:#F05F21">{{count}}</span>条信息</div>
    <div class="contentscoll">
      <van-cell is-link @click="showPopup(item)" v-for="(item,index) in data" :key="index">{{item.Title+'  ('+item.Issue_date.substring(0,10)+')'}}</van-cell>
      <van-popup v-model="show" position="right" :style="{ height: '100%',width:'100%' ,overflow: 'hidden'}" class="topmain">        
        <van-nav-bar title="MCDEX时讯"  left-text="返回" left-arrow @click-left="onClickLeft1"></van-nav-bar>
        <deptcontent v-if="show" :contentdetail="content"></deptcontent>
      </van-popup>    
    </div>
   <van-tabbar active-color="#1989fa"  inactive-color="#000" route>
      <!-- <van-tabbar-item replace to="/home" icon="wap-home-o">首页</van-tabbar-item> -->
      <van-tabbar-item replace to="/" icon="apps-o">科室分类</van-tabbar-item>
      <van-tabbar-item replace to="/PublicTiemTitle" icon="clock-o">发布时间</van-tabbar-item>
      <van-tabbar-item replace to="/Search" icon="search">搜索</van-tabbar-item>    
    </van-tabbar>
   <!-- <Nav></Nav> -->
  <div style="height:0.5rem;width:100%;"></div>
   <!-- 下拉选择 -->
   <!-- <van-picker show-toolbar :columns="columns"  @cancel="onCancel"  @confirm="onConfirm"/> -->
   <van-popup v-model="showPicker" position="bottom">
    <van-picker
      show-toolbar
      :columns="columns"
      @cancel="showPicker = false"
      @confirm="onConfirm"
    />
  </van-popup>
  </div>
</template>

<script>
import Nav from  './Nav'
import deptcontent from  './DeptContent'
import { Toast } from 'vant';
export default {
  name: 'PublicTiemTitle',  
  components:{
      Nav,
      deptcontent
  },
  data () {
    return {
      data:[],
      datasource:[],
      Listid:'',
      show: false,
      content:[],
      Mc_issue:'',
      showPicker:false,
      columns:['全部','临床应用','用药安全','新药信息','研究动态','医药动态', '用户交流', 'MCDEX快递'],
      count:0,
      title:''
    }
  },
  created(){
      this.Listid = sessionStorage.getItem("Listid");
      this.Mc_issue = sessionStorage.getItem("Mc_issue");
      this.GetDept();
  },
  methods:{    
    onClickLeft() {
      this.$router.go(-1);
    },  
    onClickLeft1(){
      this.show = false;
    },
    GetDept() {
    Toast.loading({
      forbidClick: true, // 禁用背景点击
      loadingType: 'spinner',
      message: '加载中'
    }); 
    this.$axios
      .get(window.apiUrl+"/pc/mcdex/GetPublicDeptTitle", {
        params: {
          Listid:this.Listid
        }
      })
      .then(res => {
        Toast.clear();
        if (res.data.Errs.length == 0) {
          this.data=res.data.Result;
          this.datasource=res.data.Result;
          this.count=this.data.length;
        }
      });
  },
  showPopup(item){
    this.title=item.Title;
    this.$axios
    .get(window.apiUrl+"/pc/mcdex/GetallDeptContent", {
        params: {
        Mnid:item.Mnid,
        }
    })
    .then(res => {
        if (res.data.Errs.length == 0) {
        this.content=res.data.Result;
        this.content=[...this.content,item]
        this.show = true;
        }
    });
  },
  backdepe(){
    this.$router.push({name: "Dept"});
  },
    onConfirm(value, index) {
      if(index==0){
        this.GetDept();
      }
      var temp=[];
      this.datasource.forEach(element => {
        if(element.Category==index){
          temp.push(element);
        }
      });
      this.data=temp;
      this.showPicker = false;
      this.count=this.data.length;
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.deptclass{
  height: 0.34rem;
  line-height: 0.34rem;
  padding-left: 0.1rem;
  background: #F2EEEE;
  border-bottom: 0.01rem solid #EAE1E1;
}
.span{
  padding: 0 0.1rem;
}
.spandept{
  display: inline-block;
  border-bottom: 0.01rem solid #07c160;
}
.all{
  color: #1989fa;
  float: right;
  margin-right: 0.1rem;
}

</style>



// WEBPACK FOOTER //
// src/components/PublicTiemTitle.vue